import { Component } from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatIcon} from '@angular/material/icon';
import {ChargerFormData, Connector} from "../../shared/types/chargers.model";
import {CdkDragDrop, DragDropModule, moveItemInArray} from '@angular/cdk/drag-drop';
import {ApiService} from '../../shared/services/api';

// Models for Add Charger Component
interface ChargerOwnerOption {
  id: string;
  name: string;
  email: string;
}

interface TariffPlanOption {
  id: string;
  name: string;
  pricePerKwh: number;
  cgst: number;
  sgst: number;
  igst: number;
}

interface ChargerModelOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-add-charger',
  imports: [CommonModule, FormsModule, MatIcon, DragDropModule],
  templateUrl: './add-charger.html',
  styleUrl: './add-charger.css',
})
export class AddCharger {
  // Form data model
  formData: ChargerFormData = {
    model: '',
    serialNumber: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    latitude: '',
    longitude: '',
    chargerOwnerId: '',
    tariffPlanId: '',
    connectors: []
  };

  // Options for dropdowns
  chargerModels: ChargerModelOption[] = [
    { value: 'SONIC_20', label: 'SONIC 20'},
    { value: 'SONIC_80', label: 'SONIC 80'}
  ];

  chargerOwners: ChargerOwnerOption[] = [];
  tariffPlans: TariffPlanOption[] = [];

  states = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Delhi',
    'Jammu and Kashmir',
    'Ladakh',
    'Puducherry',
    'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Lakshadweep',
    'Andaman and Nicobar Islands'
  ];

  // Display fields for tariff
  pricePerKwh: string = '';
  cgst: string = '';
  sgst: string = '';
  igst: string = '';

  connectors: Connector[] = [];

  addConnector() {
    this.connectors.push({
      plug: `Plug_${this.connectors.length + 1}`,
      plugType: ''
    });
    setTimeout(() => {
      const connectorCard = document.querySelector('.connector-card');
      connectorCard?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  removeConnector(index: number) {
    this.connectors.splice(index, 1);
    this.updatePlugNames();
  }

  onDrop(event: CdkDragDrop<Connector[]>) {
    moveItemInArray(this.connectors, event.previousIndex, event.currentIndex);
    this.updatePlugNames();
  }

  private updatePlugNames() {
    this.connectors.forEach((connector, i) => {
      connector.plug = `Plug_${i + 1}`;
    });
  }

  // Method to handle tariff plan selection
  onTariffPlanChange(planId: string) {
    const selectedPlan = this.tariffPlans.find(plan => plan.id === planId);
    if (selectedPlan) {
      this.pricePerKwh = selectedPlan.pricePerKwh.toString();
      this.cgst = selectedPlan.cgst.toString();
      this.sgst = selectedPlan.sgst.toString();
      this.igst = selectedPlan.igst.toString();
    }
  }
  constructor(private apiService: ApiService) {}
  saveCharger() {
    this.formData.connectors = this.connectors;

    console.log('Saving charger:', this.formData);

    this.apiService.addCharger(this.formData).subscribe({
      next: (response: any) => {
        console.log('Charger saved successfully:', response)
      },
      error: (error: any) => {
        console.error('Error saving charger:', error);
      }
    });
  }


  // Cancel method
  cancel() {
    // Add cancel logic here
    console.log('Cancelled');
  }
}
